import { OptionType } from '@evinced-private/ui-common';

import {
	MFA_SESSIONS_TABLE_ID,
	MFA_V1_SESSIONS_TABLE_ID,
	MOBILE_SDK_TESTS_TABLE_ID,
	MSDK_SESSIONS_TABLE_ID,
	WEB_SDK_TEST_ISSUES_TABLE_ID,
	WEB_SDK_TEST_TABLE_ID,
	WFA_SESSION_COMPONENTS_TABLE_ID,
	WFA_SESSION_ISSUES_TABLE_ID,
	WFA_SESSIONS_TABLE_ID
} from 'src/common/pages/dashboards-container/dashboard_consts';

import { sortSeverities } from '../services/severities/SeverityService';

export const DEFAULT_PERIOD_OPTION: OptionType = { value: 30, label: 'Last 30 days' };

enum FieldOptionName {
	SEVERITY = 'severity',
	TYPE = 'type',
	TAGS = 'tags'
}

interface IMfaV1SessionsFilterOption {
	searchValue?: string;
	os?: OptionType[];
	apps?: OptionType[];
	versions?: OptionType[];
}

export interface IMfaSessionsFilterOption {
	searchValue?: string;
	platform?: OptionType[];
	appName?: OptionType[];
	appVersion?: OptionType[];
	owner?: OptionType[];
	severity?: OptionType[];
	sessionsPeriod?: OptionType[];
}

export interface IWfaSessionsFilterOption {
	searchValue?: string;
	sessionsPeriod?: OptionType[];
	createdBy?: OptionType[];
}

interface IMobileSdkV1SessionsFilterOption {
	searchValue?: string;
	userLabels?: OptionType[];
}

export interface IMobileSdkTestsFilterOption {
	searchValue?: string;
	sessionsPeriod?: OptionType[];
	platform?: OptionType[];
	appName?: OptionType[];
	appVersion?: OptionType[];
	sdkType?: OptionType[];
	sdkVersion?: OptionType[];
	severity?: OptionType[];
	customFields?: OptionType[];
}

export interface IWebSdkTestsFilterOption {
	searchValue?: string;
	testPeriod?: OptionType[];
	labels?: OptionType[];
	properties?: OptionType[];
}

export interface IWebSdkTestIssuesFilterOption {
	searchValue?: string;
	severities?: OptionType[];
	types?: OptionType[];
	levels?: OptionType[];
	urls?: OptionType[];
	properties?: OptionType[];
}

interface IDashboardFilterOption {
	dateRange?: OptionType[];
	unitId?: OptionType[];
}

export interface IFilterOptions
	extends
		IWebSdkTestsFilterOption,
		IMfaV1SessionsFilterOption,
		IMfaSessionsFilterOption,
		IMobileSdkV1SessionsFilterOption,
		IMobileSdkTestsFilterOption,
		IWfaSessionsFilterOption,
		IWebSdkTestIssuesFilterOption,
		IDashboardFilterOption {}

export const naturalSort = (a: string, b: string): number => {
	return a.localeCompare(b, undefined, {
		numeric: true,
		sensitivity: 'base'
	});
};

export const orderByMethod = (values: string[] = [], option = ''): string[] => {
	if (option === FieldOptionName.SEVERITY) {
		return sortSeverities(values);
	}
	return values.sort(naturalSort);
};

export const defaultEmptyFilterOptions: IFilterOptions = {
	searchValue: '',
	os: [],
	apps: [],
	versions: [],
	userLabels: []
};

const defaultWebSdkEmptyFilterOptions: IWebSdkTestsFilterOption = {
	searchValue: '',
	testPeriod: [DEFAULT_PERIOD_OPTION],
	labels: []
};

const defaultWfaEmptyFilterOptions: IWfaSessionsFilterOption = {
	searchValue: '',
	sessionsPeriod: [DEFAULT_PERIOD_OPTION],
	createdBy: []
};

const defaultWebSdkIssuesEmptyFilterOptions: IWebSdkTestIssuesFilterOption = {
	searchValue: '',
	severities: [],
	types: [],
	urls: []
};

const defaultMobileSdkEmptyFilterOptions: IMobileSdkTestsFilterOption = {
	searchValue: '',
	sessionsPeriod: [DEFAULT_PERIOD_OPTION],
	customFields: []
};

const defaultMfaEmptyFilterOptions: IMfaSessionsFilterOption = {
	searchValue: '',
	platform: [],
	appName: [],
	appVersion: [],
	owner: [],
	severity: [],
	sessionsPeriod: [DEFAULT_PERIOD_OPTION]
};

const defaultMfaV1EmptyFilterOptions: IMfaV1SessionsFilterOption = {
	searchValue: '',
	os: [],
	apps: [],
	versions: []
};

const defaultWfaSingleSessionFilterOptions: IFilterOptions = {
	searchValue: '',
	severities: [],
	types: [],
	urls: [],
	levels: []
};

export const emptyFilterOptions = (tableIdPrefix: string): IFilterOptions => {
	switch (tableIdPrefix) {
		case WEB_SDK_TEST_TABLE_ID:
			return defaultWebSdkEmptyFilterOptions;
		case WEB_SDK_TEST_ISSUES_TABLE_ID:
			return defaultWebSdkIssuesEmptyFilterOptions;
		case MSDK_SESSIONS_TABLE_ID:
		case MOBILE_SDK_TESTS_TABLE_ID:
			return defaultMobileSdkEmptyFilterOptions;
		case MFA_SESSIONS_TABLE_ID:
			return defaultMfaEmptyFilterOptions;
		case MFA_V1_SESSIONS_TABLE_ID:
			return defaultMfaV1EmptyFilterOptions;
		case WFA_SESSIONS_TABLE_ID:
			return defaultWfaEmptyFilterOptions;
		case WFA_SESSION_ISSUES_TABLE_ID:
		case WFA_SESSION_COMPONENTS_TABLE_ID:
			return defaultWfaSingleSessionFilterOptions;
		default:
			return defaultEmptyFilterOptions;
	}
};
